import * as React from 'react';
import Svg, { SvgProps, Circle, Path } from 'react-native-svg';

const ExclamationIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Circle cx={12} cy={12} r={12} fill="#0058AD" />
    <Path
      fill="#fff"
      fillRule="evenodd"
      d="M12 7.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75Z"
      clipRule="evenodd"
    />
    <Path fill="#fff" d="M13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" />
  </Svg>
);
export default ExclamationIcon;
